import { queryClient } from '@/lib/queryClient';
import { queryKeys } from '@/lib/queryKeys';
import { getTableDisplayName } from '@/types/tables';
import type { TableLayout } from '@/types';

/**
 * Resolve a table display name for print tickets from the local tables cache.
 * Never fetches: a cache miss returns undefined so printing can continue offline.
 */
export function resolveTableName(
  organizationId: string,
  tab: { tableId?: string | null }
): string | undefined {
  if (!tab.tableId) return undefined;

  const tables = queryClient.getQueryData<TableLayout[]>(
    queryKeys.tablesLayout(organizationId)
  );
  const table = tables?.find((row) => row.id === tab.tableId);
  if (!table) return undefined;

  return getTableDisplayName(table);
}
